// DS: i7.20
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorHighlightColor = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        style: props.style
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M9.508 3.289a1 1 0 011.415.008l7.788 7.875a1 1 0 01-.02 1.426l-6.414 6.125a1 1 0 01-1.372.01l-6.586-6.126a1 1 0 01-.02-1.444L10.17 5.38l-.67-.677a1 1 0 01.008-1.414zm2.069 3.513l-5.13 5.052.156.146h9.818l.152-.145-4.996-5.053z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M17 18.497c0 .815.687 1.503 1.5 1.503s1.5-.689 1.5-1.503c0-.727-.378-1.705-1.136-2.535a.487.487 0 00-.725 0c-.76.83-1.139 1.808-1.139 2.535z"
    })));
};
EditorHighlightColor.displayName = 'EditorHighlightColor';
export default EditorHighlightColor;

//# sourceMappingURL=EditorHightlightColor.js.map